<script>
	import { getTagsOptions, isDefined } from "@xbs/lib-todo";
	import { getContext } from "svelte";

	import { Dropdown } from "@xbs/svelte-wx";
	import List from "../../library/List.svelte";
	import Icon from "../../library/Icon.svelte";
	import Input from "../../library/Input.svelte";
	import Item from "../Menu/Items/Item.svelte";

	export let api;

	$: state = api.getReactiveState();
	$: componentId = state.id;
	$: filter = state.filter;
	$: tags = state.tags;

	$: search = state.stateSearch;
	$: dropdown = $search?.dropdown;

	let self = null;
	let value = null;

	const _ = getContext("wx-i18n").getGroup("todo");

	$: if (
		isDefined($search?.value) &&
		$search.value !== ($filter?.match || "") &&
		$search.focus
	) {
		if (!$search.value?.length) {
			api.exec("set-filter", { match: null });
		} else {
			api.exec("set-filter", {
				match: $search.value,
				highlight: true,
				strict:
					$search.value?.startsWith("#") &&
					$tags.includes($search.value),
			});
		}
		if (
			self &&
			$search.value?.startsWith("#") &&
			value !== $search?.value
		) {
			openDropdown();
		} else {
			closeDropdown();
		}
	}

	function searchToggle() {
		api.exec("set-state-search", {
			...$search,
			open: !$search?.open,
		});
	}

	function searchFocus() {
		api.exec("set-state-search", {
			...$search,
			focus: true,
		});
	}

	function searchBlur() {
		api.exec("set-state-search", {
			...$search,
			focus: false,
			open: !!$search.value?.length,
		});
	}

	function dropdownItemClick(event) {
		value = event.detail.id;

		api.exec("set-state-search", {
			...$search,
			value: value?.length ? value : $search?.value,
			dropdown: { open: false },
		});
	}

	function openDropdown() {
		const options = getTagsOptions($tags, $search.value);

		setTimeout(
			() => {
				api.exec("set-state-search", {
					...$search,
					open: true,
					dropdown: {
						open: true,
						options,
					},
				});
			},
			$search?.open ? 0 : 250
		);
	}

	function closeDropdown() {
		api?.exec("set-state-search", {
			...$search,
			dropdown: {
				open: false,
			},
		});
		value = null;
	}

</script>

<div
	bind:this={self}
	data-todo-id={$componentId}
	class="wx-todo_search"
	class:wx-todo_search--opened={$search?.open}>
	<Icon name="search" clickable on:click={searchToggle} />
	{#if $search?.open}
		<div class="wx-todo_search__input">
			<Input
				placeholder={_('Search')}
				bind:value={$search.value}
				on:focus={searchFocus}
				on:blur={searchBlur} />
			{#if self && dropdown?.open && $search.value}
				<Dropdown width={'fit-content'} cancel={closeDropdown}>
					<List
						options={dropdown.options}
						on:click={dropdownItemClick}
						let:item>
						<Item {item} />
					</List>
				</Dropdown>
			{/if}
		</div>
	{/if}
</div>

<style>
	.wx-todo_search {
		display: flex;
		align-items: center;
		justify-content: flex-start;

		height: 100%;
		margin-right: 12px;
		width: 20px;

		transition: var(--wx-all-transition);
	}
	.wx-todo_search--opened {
		width: 100%;
		transition: var(--wx-all-transition);
	}
	.wx-todo_search__input {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		width: 100%;
		height: 100%;
		margin: 0 6px;
	}

</style>
